enum Icons {
  search,
  notification,
  copy,
  user,
  image,
  exit,
  bulb,
  'arrow-next',
  'arrow-prev',
  'arrow-bottom',
  stop,
  play,
  'full-screen',
  volume,
  'arrow-expand',
  'add-square',
  'scatter-up',
  heart,
  'heart-fill',
  'candlesticks-up',
  close,
  'upload-file',
  plus,
  'circle-close',
  wallet,
  check,
  'circle-and-square',
  pen,
  lightning,
  'lightning-outline',
  home,
  'home-outline',
  'close-circle-fill',
  edit,
  globe,
  share,
  more,
  instagram,
  facebook,
  twitter,
  pinterest,
  'info-circle',
  coin,
  'close-circle',
  'arrow-right-square',
  bag,
  pencil,
  filter,
  'plus-circle',
  report,
  'minus-square',
  eye,
}
export type IconNames = keyof typeof Icons;
export type IconsType = Record<IconNames, string>;
